import { render, staticRenderFns } from "./formCreateSeller.vue?vue&type=template&id=3ca4fa68"
import script from "./formCreateSeller.vue?vue&type=script&lang=js"
export * from "./formCreateSeller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ca4fa68')) {
      api.createRecord('3ca4fa68', component.options)
    } else {
      api.reload('3ca4fa68', component.options)
    }
    module.hot.accept("./formCreateSeller.vue?vue&type=template&id=3ca4fa68", function () {
      api.rerender('3ca4fa68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/sellers/components/form/formCreateSeller.vue"
export default component.exports